module.exports = __webpack_public_path__ + "static/OpenDyslexic3-Bold-57f36cc9fffd13d33a564f4d06d1b4d7.ttf";